import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  Box,
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
  Theme,
} from '../../../coreui';

import FadeIn from '../../../components/FadeIn';

const StrategyLeft = ({
  valueTop,
  labelTop,
  valueBottom,
  labelBottom,
}) => {
  return (
    <Box
      width={[1, 1, 0.5, 0.5, 0.5]}
    >
      <ExtendedFlex
        height="100%"
        flexDirection="column"
      >
        <ExtendedBox
          flex={1}
          m={0}
          p={0}
          bg="gray.0"
          height={['100%', '100%', '50%', '50%', '50%']}
          minHeight={300}
        >
          <ExtendedFlex
            height="100%"
            minHeight={300}
            flexDirection="column"
            justify="center"
            maxWidth={[null, null, 520, 600, 720]}
            // height={[300, 300, 400, 400, 500]}
            px={['15%', '25%', 60, 80, 90]}
            ml="auto"
            py={[60, 80, 0, 0, 0]}
          >
            <FadeIn>
              <Heading
                type="H3"
                textTransform="uppercase"
                m={0}
                mb="0.7em"
                opacity={1}
                transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
              >
                {labelTop}
              </Heading>
              <Body
                type="B1"
                m={0}
                opacity={1}
                transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
              >
                {ReactHtmlParser(valueTop)}
              </Body>
            </FadeIn>
          </ExtendedFlex>
        </ExtendedBox>
        <ExtendedBox
          flex={1}
          m={0}
          bg="gray.1"
          height={['100%', '100%', '50%', '50%', '50%']}
          minHeight={300}
        >
          <ExtendedFlex
            height="100%"
            minHeight={300}
            flexDirection="column"
            justify="center"
            maxWidth={[null, null, 520, 600, 720]}
            // height={[300, 300, 400, 400, 500]}
            px={['15%', '25%', 60, 80, 90]}
            ml="auto"
            py={[60, 80, 0, 0, 0]}
          >
            <FadeIn>
              <Heading
                type="H3"
                textTransform="uppercase"
                m={0}
                mb="0.7em"
                opacity={1}
                transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
              >
                {labelBottom}
              </Heading>
              <Body
                type="B1"
                m={0}
                opacity={1}
                transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
              >
                {ReactHtmlParser(valueBottom)}
              </Body>
            </FadeIn>
          </ExtendedFlex>
        </ExtendedBox>
      </ExtendedFlex>
    </Box>
  );
};

StrategyLeft.propTypes = {
  valueTop: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  labelTop: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  valueBottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  labelBottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};

export default StrategyLeft;
